module.exports = __webpack_public_path__ + "img/sign_fail.8519e0c7.png";